import React, { useState } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import useBundleTranslation from 'i18n';
import { Popup } from 'components/common/popup/Popup';

export default function RenameChatPopup({
    title,
    saving,
    error,
    onSave,
    onCancel,
}: {
    title: string;
    saving: boolean;
    error: string | null;
    onSave: (title: string) => void;
    onCancel: () => void;
}) {
    const { t } = useBundleTranslation(['app/concierge/widget']);
    const [value, setValue] = useState(title);
    const blank = '' === value.trim();

    return (
        <Popup
            open
            settings={{
                title: t('recent_chats.rename.title'),
                needTranslation: false,
                textOK: t('recent_chats.rename.save'),
                textCancel: t('recent_chats.rename.cancel'),
                dataTestOkButton: 'concierge_rename_chat_save',
                dataTestCancelButton: 'concierge_rename_chat_cancel',
            }}
            onHide={onCancel}
            // Popup's own Enter handler confirms too, so the field has none of its own.
            onConfirm={() => !blank && !saving && onSave(value.trim())}
            okDisabled={blank || saving}
            maxWidth="popupMd"
            sx={{ zIndex: (theme) => theme.zIndex.modal + 2 }}
        >
            <Box>
                <Typography component="label" htmlFor="concierge_rename_chat_title" sx={{ display: 'block', mb: 0.5 }}>
                    {t('recent_chats.rename.field')}
                </Typography>
                <TextField
                    id="concierge_rename_chat_title"
                    data-test="concierge_rename_chat_field"
                    fullWidth
                    size="small"
                    autoFocus
                    value={value}
                    onChange={(event) => setValue(event.target.value)}
                    error={!!error}
                    helperText={error ?? undefined}
                    inputProps={{ 'data-test': 'concierge_rename_chat_input', maxLength: 255 }}
                />
            </Box>
        </Popup>
    );
}
